import { render, staticRenderFns } from "./appDetails.vue?vue&type=template&id=52943dc0&scoped=true&"
import script from "./appDetails.vue?vue&type=script&lang=js&"
export * from "./appDetails.vue?vue&type=script&lang=js&"
import style0 from "./appDetails.vue?vue&type=style&index=0&id=52943dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52943dc0",
  null
  
)

export default component.exports